import { useNavigate, useSearchParams, useLocation } from 'react-router';

export default function usePageNavigation() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const pageParam = searchParams.get('current');
  const currentPage = pageParam ? parseInt(pageParam, 10) || 1 : 1;

  const navigateToPage = (page: number) => {
    const currentPath = location.pathname;
    if (page === 1) {
      navigate(currentPath);
    } else {
      navigate(`${currentPath}?current=${page}`);
    }
  };

  return { currentPage, navigateToPage };
}
